import { createApp } from "vue";
import { createI18n } from "vue-i18n";
import App from "./App.vue";
import store from "./store";
import router from "./router";

// Styles
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";

// UI Framework
import MaterialDashboard from "./material-dashboard";

// Toastification
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

// Import translations
import enSidebar from "./locales/en/sidebar.json";
import frSidebar from "./locales/fr/sidebar.json";
import enEmployees from "./locales/en/employees.json";
import frEmployees from "./locales/fr/employees.json";
import enEmployeesAdd from "./locales/en/employeesAdd.json";
import frEmployeesAdd from "./locales/fr/employeesAdd.json";
import enPersonalInfo from "./locales/en/personalInfo.json";
import frPersonalInfo from "./locales/fr/personalInfo.json";
import enProfessionalInfo from "./locales/en/professionalInfo.json";
import frProfessionalInfo from "./locales/fr/professionalInfo.json";
import enDocuments from "./locales/en/documents.json";
import frDocuments from "./locales/fr/documents.json";
import enEditEmployee from "./locales/en/editEmployee.json";
import frEditEmployee from "./locales/fr/editEmployee.json";
import enPersonalInfoEdit from "./locales/en/personalInfoEdit.json";
import frPersonalInfoEdit from "./locales/fr/personalInfoEdit.json";
import enProfessionalEdit from "./locales/en/professionalEdit.json"; 
import frProfessionalEdit from "./locales/fr/professionalEdit.json"; 
import enEditDocuments from "./locales/en/editDocuments.json";
import frEditDocuments from "./locales/fr/editDocuments.json";
import enOfficeExpenses from "./locales/en/officeExpenses.json";
import frOfficeExpenses from "./locales/fr/officeExpenses.json";
import enExpenseCategories from "./locales/en/expenseCategories.json";
import frExpenseCategories from "./locales/fr/expenseCategories.json";
import enExpenseAdd from "./locales/en/expenseAdd.json";
import frExpenseAdd from "./locales/fr/expenseAdd.json";
import enExpenseEdit from "./locales/en/expenseEdit.json";
import frExpenseEdit from "./locales/fr/expenseEdit.json";
import enLeaveRequests from "./locales/en/leaveRequests.json";
import frLeaveRequests from "./locales/fr/leaveRequests.json";
import frLeaveManage from "./locales/fr/leaveManage.json";
import enLeaveManage from "./locales/en/leaveManage.json";
import frLoanManage from "./locales/fr/loanManage.json";
import enLoanManage from "./locales/en/loanManage.json";
import enLoanRequest from "./locales/en/loanRequest.json";
import frLoanRequest from "./locales/fr/loanRequest.json";
import enSalaryReview from "./locales/en/salaryReview.json";
import frSalaryReview from "./locales/fr/salaryReview.json";
import enCertificateReview from "./locales/en/certificateReview.json";
import frCertificateReview from "./locales/fr/certificateReview.json";
import enCertificateRequest from "./locales/en/certificateRequest.json";
import frCertificateRequest from "./locales/fr/certificateRequest.json";
import enBankDetails from "./locales/en/bankDetails.json";
import frBankDetails from "./locales/fr/bankDetails.json";
import enBankEdit from "./locales/en/bankEdit.json";
import frBankEdit from "./locales/fr/bankEdit.json";
import enDashboard from "./locales/en/dashboard.json";
import frDashboard from "./locales/fr/dashboard.json";
import enAttendance from "./locales/en/attendance.json";
import frAttendance from "./locales/fr/attendance.json";
import enBonusesList from "./locales/en/bonusesList.json";
import frBonusesList from "./locales/fr/bonusesList.json";
import enAddBonuses from "./locales/en/addbonuses.json";
import frAddBonuses from "./locales/fr/addbonuses.json";
import enEditBonuses from "./locales/en/editbonuses.json";
import frEditBonuses from "./locales/fr/editbonuses.json";
import enSalaryAdvance from "./locales/en/salaryAdvance.json";
import frSalaryAdvance from "./locales/fr/salaryAdvance.json";
import enBankUser from "./locales/en/bankuser.json";
import frBankUser from "./locales/fr/bankuser.json";
import enEmployeeProfil from "./locales/en/employeeprofil.json";
import frEmployeeProfil from "./locales/fr/employeeprofil.json";
import enEditProfil from "./locales/en/editprofil.json";
import frEditProfil from "./locales/fr/editprofil.json";
import enEmployeeProfessionalInfo from "./locales/en/EmployeeProfessionalInfo.json";
import frEmployeeProfessionalInfo from "./locales/fr/EmployeeProfessionalInfo.json";
import employeedocumentsEN from "@/locales/en/employeedocuments.json";
import employeedocumentsFR from "@/locales/fr/employeedocuments.json"; 
import enEmployeeBonus from "./locales/en/employeebonus.json";
import frEmployeeBonus from "./locales/fr/employeebonus.json";
import enAuthorizationRequest from "./locales/en/authorizationRequest.json";
import frAuthorizationRequest from "./locales/fr/authorizationRequest.json";
import enAuthorizationReview from "./locales/en/authorizationReview.json";  
import frAuthorizationReview from "./locales/fr/authorizationReview.json";
import enCommon from "./locales/en/common.json";  
import frCommon from "./locales/fr/common.json"; 
import enCalendar from "./locales/en/calendar.json";  
import frCalendar from "./locales/fr/calendar.json";
import enProject from "./locales/en/project.json";
import frProject from "./locales/fr/project.json";
import enPosition from "./locales/en/position.json";
import frPosition from "./locales/fr/position.json";
import enBank from "./locales/en/bank.json";
import frBank from "./locales/fr/bank.json";
import enContractType from "./locales/en/contractType.json";
import frContractType from "./locales/fr/contractType.json";
import enCompany from "./locales/en/company.json";
import frCompany from "./locales/fr/company.json";
import enBudgetCategory from "./locales/en/budgetCategory.json";
import frBudgetCategory from "./locales/fr/budgetCategory.json";
import enBudgetSubCategory from "./locales/en/budgetSubCategory.json";
import frBudgetSubCategory from "./locales/fr/budgetSubCategory.json";
import enDocumentType from "./locales/en/documentType.json";
import frDocumentType from "./locales/fr/documentType.json";
import enCertificateType from "./locales/en/certificateType.json";
import frCertificateType from "./locales/fr/certificateType.json";
import enExpenseCategory from "./locales/en/expenseCategory.json";
import frExpenseCategory from "./locales/fr/expenseCategory.json";

// ----------------------------------------
// ✅ CREATE I18N INSTANCE (UPDATED)
// ----------------------------------------
const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: "en", // Langue par défaut
  fallbackLocale: "en", // Langue de secours si une traduction est manquante
  messages: {
    en: {
      sidebar: enSidebar,
      employees: enEmployees,
      employeesAdd: enEmployeesAdd,
      personalInfo: enPersonalInfo,
      documents: enDocuments,
      professionalInfo: enProfessionalInfo,
      personalInfoEdit: enPersonalInfoEdit,
      editEmployee: enEditEmployee,
      editDocuments: enEditDocuments,
      officeExpenses: enOfficeExpenses,
      expenseCategories: enExpenseCategories,
      expenseAdd: enExpenseAdd,
      expenseEdit: enExpenseEdit,
      leaveRequests: enLeaveRequests,
      leaveManage: enLeaveManage.leaveManage,
      loanManage: enLoanManage.loanManage,
      loanRequest: enLoanRequest.loanRequest,
      salaryReview: enSalaryReview.salaryReview,
      certificateReview: enCertificateReview,
      certificateRequest: enCertificateRequest,
      bankDetails: enBankDetails.bankDetails,
      bankEdit: enBankEdit.bankEdit,
      dashboard: enDashboard,
      attendance: enAttendance,
      bonusesList: enBonusesList,
      addbonuses: enAddBonuses,
      editbonuses: enEditBonuses,
      salaryAdvance: enSalaryAdvance,
      bankuser: enBankUser,
      employeeprofil: enEmployeeProfil,
      editprofil: enEditProfil,
      employeeProfessionalInfo: enEmployeeProfessionalInfo,
      employeedocuments: employeedocumentsEN,
      employeebonus: enEmployeeBonus,
      authorizationRequest: enAuthorizationRequest,
      professionalEdit: enProfessionalEdit,
      authorizationReview: enAuthorizationReview,
      common: enCommon,
      calendar: enCalendar,
      project: enProject,
      position: enPosition,
      bank: enBank,
      contractType: enContractType,
      company: enCompany,
      budgetCategory: enBudgetCategory,
      budgetSubCategory: enBudgetSubCategory,
      documentType: enDocumentType,
      certificateType: enCertificateType,
      expenseCategory: enExpenseCategory,
    },

    fr: {
      sidebar: frSidebar,
      employees: frEmployees,
      employeesAdd: frEmployeesAdd,
      personalInfo: frPersonalInfo,
      documents: frDocuments, 
      professionalInfo: frProfessionalInfo,
      personalInfoEdit: frPersonalInfoEdit,
      editEmployee: frEditEmployee,
      editDocuments: frEditDocuments,
      officeExpenses: frOfficeExpenses,
      expenseCategories: frExpenseCategories,
      expenseAdd: frExpenseAdd,
      expenseEdit: frExpenseEdit,
      leaveRequests: frLeaveRequests,
      leaveManage: frLeaveManage.leaveManage,
      loanManage: frLoanManage.loanManage,
      loanRequest: frLoanRequest.loanRequest,
      salaryReview: frSalaryReview.salaryReview,
      certificateReview: frCertificateReview,
      certificateRequest: frCertificateRequest,
      bankDetails: frBankDetails.bankDetails,
      bankEdit: frBankEdit.bankEdit,
      dashboard: frDashboard,
      attendance: frAttendance,
      bonusesList: frBonusesList,
      addbonuses: frAddBonuses,
      editbonuses: frEditBonuses,
      salaryAdvance: frSalaryAdvance,
      bankuser: frBankUser,
      employeeprofil: frEmployeeProfil,
      editprofil: frEditProfil,
      employeeProfessionalInfo: frEmployeeProfessionalInfo,
      employeedocuments: employeedocumentsFR, 
      employeebonus: frEmployeeBonus,
      authorizationRequest: frAuthorizationRequest,
      professionalEdit: frProfessionalEdit,
      authorizationReview: frAuthorizationReview,
      common: frCommon,
      calendar: frCalendar,
      project: frProject,
      position: frPosition,
      bank: frBank,
      contractType: frContractType,
      company: frCompany,
      budgetCategory: frBudgetCategory,
      budgetSubCategory: frBudgetSubCategory,
      documentType: frDocumentType,
      certificateType: frCertificateType,
      expenseCategory: frExpenseCategory,
    }
  }
});

// ----------------------------------------
// APP INITIALISATION
// ----------------------------------------
const appInstance = createApp(App);

appInstance.use(store);
appInstance.use(router);
appInstance.use(MaterialDashboard);
appInstance.use(i18n);

appInstance.use(Toast, {
  transition: "Vue-Toastification__fade",
  maxToasts: 5,
  newestOnTop: true,
  timeout: 3000,
  position: "top-right"
});

appInstance.mount("#app");
